import { render, staticRenderFns } from "./empower.vue?vue&type=template&id=a1fbedb8&scoped=true"
import script from "./empower.vue?vue&type=script&lang=js"
export * from "./empower.vue?vue&type=script&lang=js"
import style0 from "./empower.vue?vue&type=style&index=0&id=a1fbedb8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fbedb8",
  null
  
)

export default component.exports